const getStoreModule = (store) => {
  if (!store || !store.state || !store.state.sinvoiceCustomerConfigStore) {
    return null;
  }
  return store.state.sinvoiceCustomerConfigStore;
};

export const getSinvoiceConfig = (store) => {
  const moduleState = getStoreModule(store);
  const source = moduleState && moduleState.customerConfig ? moduleState.customerConfig : {};
  return { ...source };
};

export const hasSinvoiceConfig = (store) => {
  const moduleState = getStoreModule(store);
  if (!moduleState) return false;

  if (typeof moduleState.hasData === "boolean") {
    return moduleState.hasData;
  }

  const cfg = moduleState.customerConfig || {};
  return cfg.id !== null && cfg.id !== undefined;
};

export default {
  computed: {
    sinvoiceConfig() {
      return getSinvoiceConfig(this.$store);
    },
    hasSinvoiceCustomerConfig() {
      return hasSinvoiceConfig(this.$store);
    },
  },
  methods: {
    // Helper dùng chung cho các màn hình để tránh gọi Vuex getter trực tiếp
    getSinvoiceConfig() {
      return getSinvoiceConfig(this.$store);
    },
    hasSinvoiceConfig() {
      return hasSinvoiceConfig(this.$store);
    },
    getSinvoiceConfigField(fieldName, fallback = undefined) {
      const cfg = this.getSinvoiceConfig();
      if (!fieldName) return fallback;
      return cfg[fieldName] !== undefined ? cfg[fieldName] : fallback;
    },
  },
};

